// Copyright (c) 2022 by Move Closer

import { BenefitProgram } from '../../../loyalty/contracts/programs'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const PRODUCT_HEADER_COMPONENT_KEY = 'ProductHeaderComponent'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const PRODUCT_HEADER_DEFAULT_CONFIG = {
  badgesOnGallery: false,
  favouriteAsIcon: false,
  defaultMaxRating: 5,
  hasBenefitsBar: true,
  hasDeliveryTimer: false,
  hasGiftsBox: false,
  hasOrderDetails: false,
  icons: {
    addToCartButtonIcon: '',
    heartEmptyIcon: 'HeartEmptyIcon',
    heartFullIcon: 'HeartFullIcon',
    infoIcon: 'InfoIcon'
  },
  promotionBadgeHasLabel: false,
  variantSwitcherShowChosen: false,
  modalSize: 'medium',
  useDrawer: false,
  useVendorReviews: false,
  shouldHaveSeparatedRating: false,
  shouldHaveVisibleRating: true,
  showSingleVariantRating: false,
  fixedPrograms: [BenefitProgram.FriendsAndFamily]
}
